import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React from 'react';
import PropTypes from 'prop-types';
var LocationAutocomplete = /*#__PURE__*/function (_React$Component) {
  function LocationAutocomplete(props) {
    var _this;
    _classCallCheck(this, LocationAutocomplete);
    _this = _callSuper(this, LocationAutocomplete, [props]);
    _this.state = {
      value: props.value || ''
    };
    _this.setValue = _this.setValue.bind(_this);
    return _this;
  }
  _inherits(LocationAutocomplete, _React$Component);
  return _createClass(LocationAutocomplete, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;
      var inputId = this.props.inputId;
      var input = document.getElementById(inputId);
      if (input === null) {
        return;
      }
      var geocoder = new window.google.maps.places.Autocomplete(input);
      geocoder.setTypes(['(cities)']);
      window.google.maps.event.addDomListener(input, 'keydown', function (e) {
        if (e.keyCode === 13) {
          e.preventDefault();
        }
      });
      geocoder.addListener('place_changed', function () {
        _this2.setValue(input.value);
      });
    }
  }, {
    key: "setValue",
    value: function setValue(newValue) {
      var onValueChange = this.props.onValueChange;
      this.setState({
        value: newValue
      });
      onValueChange(newValue);
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;
      var _this$props = this.props,
        inputId = _this$props.inputId,
        value = _this$props.value,
        defaultSample = _this$props.defaultSample;
      return /*#__PURE__*/React.createElement("input", {
        placeholder: defaultSample,
        type: "text",
        id: inputId,
        name: inputId,
        value: value || this.state.value,
        onChange: function onChange(e) {
          return _this3.setValue(e.target.value);
        }
      });
    }
  }]);
}(React.Component);
LocationAutocomplete.propTypes = {
  value: PropTypes.string,
  onValueChange: PropTypes.func.isRequired,
  inputId: PropTypes.string.isRequired,
  defaultSample: PropTypes.string
};
LocationAutocomplete.defaultProps = {
  value: null,
  defaultSample: null
};
export default LocationAutocomplete;